export enum Steps {
  ACADEMIC_DATA = 'academic-data',
  UPLOAD_INSTRUCTIONS = 'upload-instructions',
  DOCUMENT_PREVIEW = 'document-preview',
  VALIDATING_ENROLLMENT = 'validating-enrollment',
  ENROLLMENT_ERROR = 'enrollment-error',
  ENROLLMENT_SUCCESS = 'enrollment-success',
}
